import { Localized } from "@fluent/react"
import { Alert, Box, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { CancelButton } from "../../../app/components/CancelButton";
import { deleteCompanyMapping } from "./CompanyMappingsApi";
import { DeleteButton } from "../../../app/components/DeleteButton";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";

interface DeleteCompanyMappingDialogProps {
    companyMappingId: string;
    onDeleteSuccess: (id: string) => void;
    onCancel: () => void;
}

export const DeleteCompanyMappingDialog: React.FC<DeleteCompanyMappingDialogProps> = ({ companyMappingId, onDeleteSuccess, onCancel }) => {
    const dispatch = useAppDispatch();

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);
    
    const handleConfirm = async () => {
        try {
            const result = await dispatch(deleteCompanyMapping(companyMappingId))
            if (deleteCompanyMapping.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onDeleteSuccess(companyMappingId);
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="default-company-settings-generate-script">
                        <span>_Usuń mapowanie</span>
                    </Localized>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Localized id="company-supplier-mappings-delete-question">
                    <span>_Czy na pewno chcesz usunąć to mapowanie?</span>
                </Localized>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}